import Header from '../../components/Navigation/Header';
import './ProfileSetup.css';
import { useNavigate } from 'react-router-dom';
import usericon from '../../Assets/Images/RegisterPage/user.png';

import cameraicon from '../../Assets/Images/RegisterPage/camera.png';
import emailicon from '../../Assets/Images/RegisterPage/mail.png';
import phoneicon from '../../Assets/Images/RegisterPage/telephone.png';
import browse from '../../Assets/Images/RegisterPage/browse.png';
import aistar from '../../Assets/Images/RegisterPage/aistar.png';

import { useContext, useEffect, useState } from 'react';
import { userDetails } from '../../context/User.jsx';
import { fetchDomains, fetchExperiences, fetchRoles, ProfileSetupFetch } from '../../services/user.jsx';
import { useRef } from 'react';

function ProfileSetup() {
    const navigate = useNavigate();
    const { user } = useContext(userDetails);

    const [preview, setPreview] = useState('');
    const [error, setError] = useState('');
    const [profileImage, setProfileImage] = useState(usericon);
    const [fileName, setFileName] = useState('Browse');

    const [yoeLabel, setYOELabel] = useState('');
    const [currentSalaryLabel, setcurrentSalaryLabel] = useState();
    const [expectedSalaryLabel, setexpectedSalaryLabel] = useState('');
    const [currentLocationLabel, setcurrentLocationLabel] = useState('');
    const [preferredLocationLabel, setPreferredLocationLabel] = useState('');
    const [currentWorkModeLabel, setCurrentWorkModeLabel] = useState('');
    const [employementTypeLabel, setEmployementTypeLabel] = useState('');
    const [preferredLabel, setpreferredLabel] = useState('');
    const [preferredEmployementTypeLabel, setPreferredEmployementTypeLabel] = useState('');
    const [preferredWorkModeLabel, setPreferredWorkModeLabel] = useState('');
    const [summaryLabel, setSummaryLabel] = useState('');
    const [currentRoleLabel, setCurrentRoleLabel] = useState('');
    const [currentDomainLabel, setCurrentDomainLabel] = useState('');
    const [preferedRoleLabel, setPreferedRoleLabel] = useState('');
    const [preferedDomainLabel, setPreferedDomainLabel] = useState('');
    const [preferedExperienceLabel, setpreferedExperienceLabel] = useState('');

    const profileData = useRef(new FormData());

    const [updateProfile, setUpdateProfile] = useState(false);
    const [reponseProfileSubmission, setReponseProfileSubmission] = useState('');

    const [states, setStates] = useState('');
    const [currentlocation, setcurrentlocation] = useState(user.profile.currentLocation);
    const [currentWorkMode, setCurrentWorkMode] = useState(user.profile.currentWorkMode);
    const [currentRole, setCurrentRole] = useState(user.profile.currentWorkMode);
    const [currentDomain, setCurrentDomain] = useState(user.profile.currentDomain);
    const [experienceYear, setExperienceYear] = useState(user.profile.yearsOfExperience);

    const [currentSalary, setCurrentSalary]=useState(user.profile.currentSalary);
    const [currentEmployementType, setCurrentEmployementType] = useState(user.profile.currentEmploymentType || '');
    const [preferredWorkMode, setPreferredWorkMode] = useState(user.profile.preferredWorkMode || '');
    const [preferredEmployementType, setPreferredEmployementType] = useState(user.profile.preferredEmploymentType || '');
    const [preferredRole, setPreferredRole] = useState(user?.profile?.registeredPosition?.role || '');
    const [preferredDomain, setPreferredDomain] = useState(user?.profile?.registeredPosition?.primaryDomain || '');
    const [preferredExperience, setPreferredExperience] = useState(user?.profile?.registeredPosition?.experienceLevel || '');
    const [expectedSalary, setExpectedSalary]= useState(user.profile.expectedSalary || '');
    const [preferredLocations, setPreferredLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [summary, setSummary] = useState(user.profile.summary || '');
    const [preferredDomains, setPreferredDomains] = useState([]);

    const [characterCount,setCharacterCount] =useState(0);

    const [roles, setRoles]=useState([]);
    const [domains, setDomains] =useState([]);
    const [experiences, setExperiences] =useState([]);

    const [isEditing, setIsEditing] = useState(false);
    // Function to handle image file selection
    const HandleProfileImage = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                setProfileImage(e.target.result);
            };

            reader.readAsDataURL(file);
            profileData.current.append("image", file);
        }
    }

    const HandleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file) {
                setFileName(file.name);
                profileData.current.append("resume", file);
            }
        }
    }

    async function HandleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());

        data.preferredLocation = preferredLocations.length > 0 ? preferredLocations : [];
        data.preferredDomains = preferredDomains.length > 1 
        ? preferredDomains.slice(1)  // Remove first element (primary domain)
        : []; 
        console.log('data', data);

    
        const profile_Data = new FormData();

        if (profileData.current.has('image')) profile_Data.append('image', profileData.current.get('image'));
        if (profileData.current.has('resume')) profile_Data.append('resume', profileData.current.get('resume'));

        let format = true;
        const validateNumber = (value, setter) => {
            if (!value) {
                setter('Field required!');
                return false;
            }
            if (isNaN(value)) {
                setter('Please enter a valid number!');
                return false;
            }
            return true;
        };

        // Helper function for text validation
        const validateText = (value, setter) => {
            if (!value || value.trim() === "") {
                setter('Field required!');
                return false;
            }
            if (!isNaN(value)) {
                setter('Please enter a valid text!');
                return false;
            }
            return true;
        };

        
        // Validate numeric fields
        format &= validateNumber(data.yearsexperience, setYOELabel);
        format &= validateNumber(data.currentsalary, setcurrentSalaryLabel);
        format &= validateNumber(data.expectedsalary, setexpectedSalaryLabel);


        format &= validateText(data.currentlocation, setcurrentLocationLabel);
        format &= validateText(data.currentWorkMode, setCurrentWorkModeLabel);
        format &= validateText(data.currentEmploymentType, setEmployementTypeLabel);
        format &= validateText(data.currentRole, setCurrentRoleLabel);
        format &= validateText(data.currentDomain, setCurrentDomainLabel);

        // format &= validateNumber(data.preferredRole, setPreferedRoleLabel);
        // format &= validateNumber(data.preferredDomain, setPreferedDomainLabel);
        format &= validateText(data.preferredWorkMode, setPreferredWorkModeLabel);
        format &= validateText(data.preferredEmploymentType, setPreferredEmployementTypeLabel);
        format &= validateText(data.summary, setSummaryLabel);

        if (data.preferredLocation.length === 0) {
            setPreferredLocationLabel('Please select at least one location!');
            format = false;
        } else {
            setPreferredLocationLabel('');
        }

        // Stop execution if validation fails
        if (!format) return;
        const selectedRole = roles.find(r => r.id === parseInt(data.preferredRole));
        const selectedDomain = domains.find(d => d.id === parseInt(data.preferredDomain));
            
        //     // Replace IDs with objects
        // data.preferredRole = JSON.stringify({ 
        //     id: parseInt(data.preferredRole), 
        //     name: selectedRole?.name 
        // });
        data.preferredDomains = JSON.stringify(data.preferredDomains);
        console.log('profileData',    data.preferredDomains );
        setYOELabel('');
        setcurrentSalaryLabel('');
        setexpectedSalaryLabel('');
        setcurrentLocationLabel('');
        setSummaryLabel('');
        setCurrentWorkModeLabel('');
        setCurrentDomainLabel('');
        setCurrentRoleLabel('');
        setEmployementTypeLabel('');
        setPreferredEmployementTypeLabel('');
        setPreferredWorkModeLabel('');
        setPreferedRoleLabel('');
        setPreferedDomainLabel('');
        setpreferedExperienceLabel('');
        setPreferedDomainLabel('');
        const profileResponse = await ProfileSetupFetch(data, profile_Data);

        console.log('profileResponse', data);
        if (profileResponse) {
            setUpdateProfile(true);
            setReponseProfileSubmission(profileResponse.message)
        }
    }

    useEffect(() => {
        const findStates = async () => {
            const headers = new Headers();
            headers.append("X-CSCAPI-KEY", "RWEyVkd0eFhsSGdtNmZ3RU5IWlZJNVQ2QUVyZGVET1JnVW5yOHZ2dg==");
            headers.append('Content-Type', 'application/json');

            const requestOptions = {
                method: 'GET',
                headers,
                redirect: 'follow'
            };

            try {
                const response = await fetch("https://api.countrystatecity.in/v1/countries/IN/cities", requestOptions);
                const data = await response.json();
                if (Array.isArray(data)) {
                    setStates(data);
                } else {
                    setStates([]);
                    console.error("API response is not an array", data);
                }
            } catch (error) {
                console.error("Error fetching cities:", error);
                setStates([]);
            }
        };

        findStates();
    }, []);
    
    const getRoles=async ()=>{
        const roles=await fetchRoles();
        if(roles.success)
        {
            console.log(roles.data,'roles');
            setRoles(roles.data);
        }
        else
        {
            console.log("error");
        }
    }

    const getDomains=async ()=>{
        const domains=await fetchDomains();
        if(domains.success)
        {
            console.log(domains.data,'domains');

            const filterAllDomainField = domains.data.filter(e=>e.name !== 'All Domains')  
            setDomains(filterAllDomainField);
        }
        else
        {
            console.log("error");
        }
    }
      const getExperiences=async ()=>{
        const experiences=await fetchExperiences();
        if(experiences.success)
        {
            console.log(experiences.data,'experiences');

            setExperiences(experiences.data);
        }
        else
        {
            console.log("error");
        }
    }

    useEffect(()=>{
       getRoles();
       getDomains();
       getExperiences()
    },[]);


    useEffect(()=>{
        console.log('user details',user);
    },[])

    useEffect(() => {
    // Your existing code to fetch user data...
    if (user?.profile?.registeredPosition?.primaryDomain) {
        const primaryDomain = user.profile.registeredPosition.primaryDomain;
        
        // If user has additional domains saved, combine them
        if (user?.profile?.preferredDomains && user.profile.preferredDomains.length > 0) {
            // Check if primary domain is already in the array
            if (!user.profile.preferredDomains.includes(primaryDomain)) {
                setPreferredDomains([primaryDomain, ...user.profile.preferredDomains]);
            } else {
                setPreferredDomains(user.profile.preferredDomains);
            }
        } else {
            // Only primary domain
            setPreferredDomains([primaryDomain]);
        }
    }
    // Add this to populate preferred locations when data loads
    if (user?.profile?.preferred) {
        // If preferred is a string (single location)
        if (typeof user.profile.preferred === 'string') {
            setPreferredLocations([user.profile.preferred]);
        }
        // If preferred is already an array (multiple locations)
        else if (Array.isArray(user.profile.preferred)) {
            setPreferredLocations(user.profile.preferred);
        }
    }
    
    // Also set character count for summary if it exists
    if (user?.profile?.summary) {
        setCharacterCount(user.profile.summary.length);
    }

    // console.log('pref',user.profile.preferredRole.name);
    
    }, [user]);

    return (
        <>
            <Header recentlyUpdated={updateProfile} />
            <div className='new-profile-container'>
                <div className='new-profile-header'>
                    <div>
                     <h1>Profile Setup</h1>
                    <p>Please enter the following detail to complete your profile.</p>
                    </div>
                 
                      <div className='edit-profile-section'>
                            <button 
                                type='button' 
                                className='edit-profile-button'
                                onClick={() => setIsEditing(!isEditing)}
                            >
                                {isEditing ? 'Cancel' : 'Edit Profile'}
                            </button>
                        </div>
                </div>
                      
                <form className='new-profile-form' onSubmit={HandleSubmit}>
                    {/* Profile Photo Section */}
                    <div className='form-section'>
                      <div className='description'>
                        <h2 className='section-title'>Profile Photo</h2>
                        <p className='section-subtitle'>This image will be shown publicly as your profile picture, it will help recruiters recognize you!</p>
                        </div>
                        <div className='profile-photo-container'>
                            <div className='profile-photo-preview'>
                                <img src={profileImage} alt='profile' className='profile-image' />
                            </div>
                            <div className='profile-photo-upload'>
                                <div className='upload-box'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8B0000" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                        <polyline points="17 8 12 3 7 8"></polyline>
                                        <line x1="12" y1="3" x2="12" y2="15"></line>
                                    </svg>
                                    <label htmlFor="photoInput" className='upload-label'>
                                        <span className='upload-text'>Click to upload</span> or drag and drop
                                    </label>
                                    <p className='upload-hint'>SVG, PNG, JPG or GIF (max. 400 x 400px)</p>
                                    <input type="file" id="photoInput" style={{ display: 'none' }}
                                        onChange={(e) => HandleProfileImage(e)} accept="image/*" disabled={!isEditing}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Personal Details Section */}
                    <div className='form-section'>
                        <h2 className='section-title'>Personal Details</h2>
                        <div className='form-grid'>
                            <div className='form-field'>
                                <label>Full Name <span className='required'>*</span></label>
                                <input type='text' placeholder='Enter your full name' defaultValue={user.name} disabled={!isEditing} />
                            </div>
                            <div className='form-field'>
                                <label>Phone Number <span className='required'>*</span></label>
                                <input type='text' placeholder='Enter your phone number' defaultValue={user.phoneNumber} disabled={!isEditing} />
                            </div>
                            <div className='form-field'>
                                <label>Email <span className='required'>*</span></label>
                                <input type='email' placeholder='Enter email address' defaultValue={user.email} disabled={!isEditing} />
                            </div>
                        </div>
                    </div>

                    {/* Current Details Section */}
                    <div className='form-section'>
                        <h2 className='section-title'>Current Details</h2>
                        <div className='form-grid'>
                            <div className='form-field'>
                                <label>Current Employment Type <span className='required'>*</span></label>
                                <select name='currentEmploymentType' value={currentEmployementType||user.profile.currentEmploymentType} onChange={(e) => setCurrentEmployementType(e.target.value)} disabled={!isEditing}>
                                    <option value=''>Current Employment Type *</option>
                                    <option>Full Time</option>
                                    <option>Part Time</option>
                                </select>
                                {employementTypeLabel && <span className='error-label'>{employementTypeLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Current Salary <span className='required'>*</span></label>
                                <input type='number' placeholder='Enter Current Salary' name='currentsalary' onChange={(e)=>setCurrentSalary(e.target.value)} value={ currentSalary ||  user.profile.currentSalary} disabled={!isEditing} />
                                {currentSalaryLabel && <span className='error-label'>{currentSalaryLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Current Location <span className='required'>*</span></label>
                                {states?.length > 0 ? (
                                    <select name='currentlocation' onChange={(e) => setcurrentlocation(e.target.value)} value={currentlocation || user.profile.currentLocation} disabled={!isEditing}>
                                        <option value=''>Current Location</option>
                                        {states?.map((e, key) => (
                                            <option key={key} value={e.name}>{e.name}</option>
                                        ))}
                                    </select>
                                ) : undefined}
                                {currentLocationLabel && <span className='error-label'>{currentLocationLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Current Work Mode <span className='required'>*</span></label>
                                <select name='currentWorkMode' onChange={(e) => setCurrentWorkMode(e.target.value)} value={currentWorkMode || user.profile.currentWorkMode} disabled={!isEditing}>
                                    <option value=''>Current Work Mode *</option>
                                    <option>Virtual</option>
                                    <option>In-person</option>
                                    <option>Hybrid</option>
                                </select>
                                {currentWorkModeLabel && <span className='error-label'>{currentWorkModeLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Current Role <span className='required'>*</span></label>
                                <input type='text' placeholder='Enter Current Role' name='currentRole' onChange={(e) => setCurrentRole(e.target.value)} value={currentRole ||  user.profile.currentRole} disabled={!isEditing}/>
                                {currentRoleLabel && <span className='error-label'>{currentRoleLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Current Domain <span className='required'>*</span></label>
                                <input type='text' placeholder='Enter Current Domain' name='currentDomain' onChange={(e) => setCurrentDomain(e.target.value)}  value={currentDomain || user.profile.currentDomain} disabled={!isEditing}/>
                                {currentDomainLabel && <span className='error-label'>{currentDomainLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Years Of Experience <span className='required'>*</span></label>
                                <input type='number' placeholder='Enter Years Of Experience' name='yearsexperience' onChange={(e) => setExperienceYear(e.target.value)} value={experienceYear || user.profile.yearsOfExperience} disabled={!isEditing}/>
                                {yoeLabel && <span className='error-label'>{yoeLabel}</span>}
                            </div>
                        </div>
                    </div>

                    {/* Preferred Details Section */}
                    <div className='form-section'>
                        <h2 className='section-title'>Preferred Details</h2>
                        <div className='form-grid'>
                            <div className='form-field'>
                                <label>Preferred Employment Type <span className='required'>*</span></label>
                                <select name='preferredEmploymentType' onChange={(e) => setPreferredEmployementType(e.target.value)} value={preferredEmployementType ||  user.profile.preferredEmploymentType} disabled={!isEditing}>
                                    <option value=''>Preferred Employment Type *</option>
                                    <option>Full Time</option>
                                    <option>Part Time</option>
                                </select>
                                {preferredEmployementTypeLabel && <span className='error-label'>{preferredEmployementTypeLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Expected Salary <span className='required'>*</span></label>
                                <input type='number' placeholder='Enter Expected Salary' name='expectedsalary' onChange={(e) => setExpectedSalary(e.target.value)} value={ expectedSalary || user.profile.expectedSalary} disabled={!isEditing}/>
                                {expectedSalaryLabel && <span className='error-label'>{expectedSalaryLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Preferred location <span className='required'>*</span></label>
                                <div className="multiselect-wrapper">
                                    <select
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value && !preferredLocations.includes(value)) {
                                                 if (preferredLocations.length >= 3) {
                                                            setPreferredLocationLabel('You can select maximum 3 preferred locations');
                                                            return;
                                                }
                                                else
                                                {
                                                    setPreferredLocationLabel("")
                                                }
                                                setPreferredLocations([...preferredLocations, value]);
                                            }
                                            setSelectedLocation('');
                                        }}
                                        value={user.profile.preferred}  disabled={!isEditing}>
                                        <option value="">Enter Preferred Location</option>
                                        {states.length > 0 && states.map((e, key) =>
                                            !preferredLocations.includes(e.name) && (
                                                <option key={key} value={e.name}>{e.name}</option>
                                            )
                                        )}
                                    </select>
                                    <div className="selected-chips">
                                        {preferredLocations.map((loc, idx) => (
                                            <div key={idx} className="chip">
                                                {loc}
                                                <span className="chip-remove"
                                                                    onClick={() => {
                                                                        if (isEditing) {
                                                                            setPreferredLocations(preferredLocations.filter((item) => item !== loc));
                                                                        }
                                                                    }}
                                                                    style={{ 
                                                                        cursor: isEditing ? 'pointer' : 'not-allowed', 
                                                                        opacity: isEditing ? 1 : 0.5 
                                                                    }}>
                                                                    &times;
                                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {preferredLocationLabel && <span className='error-label'>{preferredLocationLabel}</span>}
                            </div>
                            <div className='form-field'>
                                <label>Preferred Work Mode <span className='required'>*</span></label>
                                <select name='preferredWorkMode' onChange={(e) => setPreferredWorkMode(e.target.value)}   value={ preferredWorkMode || user.profile.preferredWorkMode} disabled={!isEditing}>
                                    <option value=''>Preferred Work Mode *</option>
                                    <option>Virtual</option>
                                    <option>In-person</option>
                                    <option>Hybrid</option>
                                </select>
                                {preferredWorkModeLabel && <span className='error-label'>{preferredWorkModeLabel}</span>}
                            </div>
                                <div className='form-field'>
                                <label>Preferred Role <span className='required'>*</span></label>
                                <select name='preferredRole' onChange={(e) => setPreferredRole(e.target.value)} value={preferredRole}  disabled>
                                    <option value=''>Preferred Role *</option>
                                    {
                                        roles?roles.map(role=>(
                                            <option value={role.name}>{role.name}</option>
                                          )):undefined
                                    }
                                </select>
                                {preferedRoleLabel && <span className='error-label'>{preferedRoleLabel}</span>}
                            </div>
                             {/* Preferred Domains (First one fixed, rest editable) */}
                        <div className='form-field' >
                                <label>Preferred Domains <span className='required'>*</span></label>
                                <div className="multiselect-wrapper">
                                    <select
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value && !preferredDomains.includes(value)) {
                                                if (preferredDomains.length >= 3) {
                                                    setPreferedDomainLabel('You can select maximum 3 domains');
                                                    return;
                                                }
                                                setPreferredDomains([...preferredDomains, value]);
                                            }
                                            e.target.value = '';
                                        }}
                                        disabled={!isEditing}>
                                        <option value="">Select domains</option>
                                        {domains.map((domain) => 
                                            !preferredDomains.includes(domain.name) && (
                                                <option key={domain.id} value={domain.name}>{domain.name}</option>
                                            )
                                        )}
                                    </select>
                                    
                                    <div className="selected-chips">
                                        {preferredDomains.map((domain, idx) => {
                                            const isPrimary = idx === 0;
                                            return (
                                                <div key={idx} className="chip">
                                                    {domain}
                                                    {!isPrimary && (
                                                        <span 
                                                            className="chip-remove"
                                                            onClick={() => {
                                                                if (isEditing) {
                                                                    setPreferredDomains(preferredDomains.filter((item) => item !== domain));
                                                                }
                                                            }}
                                                            style={{ 
                                                                cursor: isEditing ? 'pointer' : 'not-allowed', 
                                                                opacity: isEditing ? 1 : 0.5 
                                                            }}>
                                                            &times;
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                {preferedDomainLabel && <span className='error-label'>{preferedDomainLabel}</span>}
                            </div>
                              <div className='form-field'>
                                <label>Preferred Experience <span className='required'>*</span></label>
                                <select name='preferredExperience' onChange={(e) => setPreferredExperience(e.target.value)} value={preferredExperience}  disabled>
                                    <option value=''>Preferred Experience *</option>
                                     {
                                        experiences?experiences.map(experience=>
                                            (<option value={experience.experience}>{experience.experience}</option>)
                                        ):undefined
                                    }
                                </select>
                                {preferedExperienceLabel && <span className='error-label'>{preferedExperienceLabel}</span>}
                            </div>
                        </div>
                    </div>

                    {/* Resume & Summary Section */}
                    <div className='form-section'>
                        <h2 className='section-title'>Resume & Summary</h2>
                        <div className='form-grid attach'>
                            <div className='field-flex resume-field'>
                                <label>Attach Your Resume <span className='required'>*</span></label>
                                <div className='resume-upload-box'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8B0000" strokeWidth="2">
                                        <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                                    </svg>
                                    <label htmlFor="fileInput" className='resume-upload-label'>
                                        Attach Resume/CV
                                    </label>
                                    <input type="file" id="fileInput" style={{ display: 'none' }}
                                        onChange={(e) => HandleFileChange(e)} accept=".pdf,.doc,.docx,.txt,.xlsx,.pptx" disabled={!isEditing}/>
                                    {fileName !== 'Browse' && <p className='file-name'>{fileName}</p>}
                                </div>
                            </div>
                            <div className='form-field summary-field'>
                                <label>Summary <span className='required'>*</span></label>
                                <textarea placeholder='Add a summary or anything else you want to share' 
                                    name="summary" rows="6" maxLength="500" onChange={(e)=>{setSummary(e.target.value);setCharacterCount(e.target.value.length)}} value={ summary || user.profile.summary} disabled={!isEditing}></textarea>
                                <div className='textarea-footer'>
                                    {/* <div className='textarea-icons'>
                                        <button type='button'>😊</button>
                                        <button type='button'><strong>B</strong></button>
                                        <button type='button'><em>I</em></button>
                                        <button type='button'>• List</button>
                                        <button type='button'>1. List</button>
                                        <button type='button'>🔗</button>
                                    </div> */}
                                    <span className='char-count'>{characterCount} / 500</span>
                                </div>
                                <p className='textarea-hint'>Maximum 500 characters</p>
                                {summaryLabel && <span className='error-label'>{summaryLabel}</span>}
                            </div>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className='form-submit'>
                        {reponseProfileSubmission && <span className='success-message'>{reponseProfileSubmission}</span>}
                        <button type='submit' className='submit-button' disabled={!isEditing}>Save Profile</button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default ProfileSetup;